import { createSlice, current } from "@reduxjs/toolkit"

const initialState = {
  viewInfos: [],
};

export const viewState = createSlice({
  name: "viewStates",
  initialState,
  reducers: {
    updateViewState: (state, action) => {
      const viewInfos = current(state.viewInfos);
      const { payload } = action;

      const findState = viewInfos.find((viewInfo) => {
        return viewInfo.viewName === payload.viewName;
      });

      if (findState?.viewName) {
        const result = [];
        viewInfos.forEach((item) => {
          return item.viewName === findState.viewName ? result.push({ ...item, ...payload }) : result.push(item);
        });
        state.viewInfos = result;
      } else {
        state.viewInfos = viewInfos.concat(payload);
      }
    },
    removeViewState: (state, action) => {
      const viewInfos = current(state.viewInfos);
      const { payload } = action;

      const findState = viewInfos.find((item) => {
        return item.viewName === payload?.viewName;
      });

      if (findState?.viewName) {
        state.viewInfos = viewInfos.filter(item => item.viewName !== findState.viewName);
      } else {
        state.viewInfos = viewInfos;
      }
    },
    initViewState: (state) => {
      state.viewInfos = [];
    },
  }
})

export const { updateViewState, removeViewState, initViewState } = viewState.actions;

export default viewState.reducer;